import axiosClient from "./axiosClient";

const serviceUrl = "/qlkhambenh/dieu-duong-noi-tru";
const serviceUrl2 = "/qlkhambenh";
const inpatientService = {
  getListInpatient: async (page, limit, params) => {
    const url =
      serviceUrl + `/danh-sach-benh-nhan/search?page=${page}&limit=${limit}`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  getInpatientById: async params => {
    const url = serviceUrl + `/danh-sach-benh-nhan`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getListDanhMucGiuongBenh: async params => {
    const url = serviceUrl + `/danh-muc-giuong-benh`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getListDanhMucPhongBenh: async params => {
    const url = serviceUrl + `/danh-muc-phong-benh`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  putLuuThongTinNhapVien: async params => {
    const url = serviceUrl + `/thong-tin-nhap-vien?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getThongTinNhapVien: async params => {
    const url = serviceUrl + `/thong-tin-nhap-vien`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  putLuuThongTinDieuTri: async params => {
    const url = serviceUrl + `/thong-tin-dieu-tri?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  searchDanhSachDieuTriNoiTru: async (page, limit, params) => {
    const url = `${serviceUrl2}/dieu-tri-noi-tru/danh-sach-noi-tru/search?page=${page}&limit=${limit}`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  getThongTinBenhNhan: async id => {
    const url = `${serviceUrl2}/dieu-tri-noi-tru/danh-sach-noi-tru`;
    const response = await axiosClient.get(url, {params: {id}});
    return response.data;
  },
  deleteBenhNhan: async id => {
    const url = `${serviceUrl2}/dieu-tri-noi-tru/danh-sach-noi-tru`;
    const response = await axiosClient.delete(url, {params: {id}});
    return response.data;
  },
  delInpatient: async params => {
    const url = serviceUrl + `/danh-sach-benh-nhan?id=${params.id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  getTinhTrangNoiTru: async () => {
    const url = `/qlkhambenh/noi-tru/danh-sach-co-dinh-by-param?param=trang_thai_dieu_duong_noi_tru`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  // getListDanhMucGiuongBenh: async (params) => {
  //     const url = serviceUrl + `/danh-muc-giuong-benh`
  //     const response = await axiosClient.get(url, { params: params });
  //     return response.data;
  // },
  // getListDanhMucPhongBenh: async (params) => {
  //     const url = serviceUrl + `/danh-muc-phong-benh`
  //     const response = await axiosClient.get(url, { params: params });
  //     return response.data;
  // },
  // putLuuThongTinNhapVien: async (params) => {
  //     const url = serviceUrl + `/thong-tin-nhap-vien?id=${params.id}`
  //     const response = await axiosClient.put(url, params);
  //     return response.data;
  // },
  // getThongTinNhapVien: async (params) => {
  //     const url = serviceUrl + `/thong-tin-nhap-vien`
  //     const response = await axiosClient.get(url, { params: params });
  //     return response.data;
  // },
  getThongTinDieuTri: async params => {
    const url = serviceUrl + `/thong-tin-dieu-tri`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  postAddBedCatalog: async params => {
    const url = serviceUrl + `/danh-muc-giuong-benh`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  getDanhMucDichVuGiuong: async () => {
    const url = `/qlkhambenh/dm-dich-vu/list-dm-dich-vu-giuong`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postAddRoomCatalog: async params => {
    const url = serviceUrl + `/danh-muc-phong-benh`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putBedCatalog: async params => {
    const url = serviceUrl + `/danh-muc-giuong-benh?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  putRoomCatalog: async params => {
    const url = serviceUrl + `/danh-muc-phong-benh?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  delBedCatalog: async params => {
    const url = serviceUrl + `/danh-muc-giuong-benh?id=${params.id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  delRoomCatalog: async params => {
    const url = serviceUrl + `/danh-muc-phong-benh?id=${params.id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  getThongTinDieuTriNoiTru: async params => {
    const url =
      serviceUrl2 + `/dieu-tri-noi-tru/thong-tin-dieu-tri?id=${params.id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  putLuuThongTinDieuTriNoiTru: async params => {
    const url =
      serviceUrl2 + `/dieu-tri-noi-tru/thong-tin-dieu-tri?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getDanhMucCoDinh: async param => {
    const url =
      serviceUrl2 + `/noi-tru/danh-sach-co-dinh-by-param?param=${param}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  putDuDieuKienPT: async id => {
    const url =
      serviceUrl2 + `/dieu-tri-noi-tru/du-dieu-kien-phau-thuat?id=${id}`;
    const response = await axiosClient.put(url);
    return response.data;
  },
  putHoanThanhDieuTri: async id => {
    const url = serviceUrl2 + `/dieu-tri-noi-tru/hoan-thanh?id=${id}`;
    const response = await axiosClient.put(url);
    return response.data;
  },
  getThongTinXuatVien: async params => {
    const url = serviceUrl + `/thong-tin-xuat-vien?id=${params.id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postXuatVien: async params => {
    const url = serviceUrl + `/xuat-vien?id=${params.id}`;
    const response = await axiosClient.post(url);
    return response.data;
  },
  putLuuThongTinXuatVien: async params => {
    const url = serviceUrl + `/thong-tin-xuat-vien?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  postTiepNhan: async params => {
    const url = serviceUrl + `/thong-tin-nhap-vien/tiep-nhan?id=${params.id}`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  postHuyTiepNhan: async params => {
    const url =
      serviceUrl + `/thong-tin-nhap-vien/huy-tiep-nhan?id=${params.id}`;
    const response = await axiosClient.post(url);
    return response.data;
  },
  getDanhMucKQDieuTri: async () => {
    const url = `/qlkhambenh/noi-tru/danh-sach-co-dinh-by-param?param=ket_qua_dieu_tri`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getDanhMucTTRaVien: async () => {
    const url = `/qlkhambenh/noi-tru/danh-sach-co-dinh-by-param?param=tinh_trang_ra_vien`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postToDieuTri: async params => {
    const url = `/qlkhambenh/dieu-tri-noi-tru/to-dieu-tri`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putToDieuTri: async params => {
    const url = `/qlkhambenh/dieu-tri-noi-tru/to-dieu-tri?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  postPhieuChiDinh: async params => {
    const url = `/qlkhambenh/phieu-chi-dinh`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  postDonThuoc: async (params, idPhieuKham?: any) => {
    let url = `/qlkhambenh/don-thuoc`;
    if (idPhieuKham) {
      url += `?idPhieuKham=${idPhieuKham}`;
    }
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  getChiDinhCongKhaiDichVu: async params => {
    let url = `/qlttbhyt-service/thanh-toan/chi-dinh-cong-khai-dich-vu`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  deleteToDieuTri: async params => {
    let url = `/qlkhambenh/dieu-tri-noi-tru/to-dieu-tri?id=${params.id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  updateThoiGianChiDinh: async params => {
    let url = `/qlkhambenh/phieu-chi-dinh/update-ngay-chi-dinh`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteChiDinh: async id => {
    let url = `/qlkhambenh/chi-dinh?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  deletePhieuChiDinh: async id => {
    let url = `/qlkhambenh/phieu-chi-dinh?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  getToDieuTri: async id => {
    let url = `/qlkhambenh/dieu-tri-noi-tru/to-dieu-tri?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListPhuThu: async idPhieuKham => {
    let url = `/qlkhambenh/phieu-chi-dinh/list-chi-dinh-phu-thu?idPhieuKham=${idPhieuKham}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListThuocChinhByIdPhieuDieuTri: async idPhieuDieuTri => {
    let url = `/qlkhambenh/don-thuoc/list-don-thuoc-by-id-phieu-dieu-tri-noi-tru?idPhieuDieuTriNoiTru=${idPhieuDieuTri}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListThuocPhuByIdPhieuDieuTri: async idPhieuDieuTri => {
    let url = `/qlkhambenh/don-thuoc-phu/list-don-thuoc-phu-by-id-phieu-dieu-tri-noi-tru?idPhieuDieuTriNoiTru=${idPhieuDieuTri}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postDonThuocChinh: async params => {
    let url = `/qlkhambenh/don-thuoc`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDonThuocChinh: async params => {
    let url = `/qlkhambenh/don-thuoc?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  postDonThuocPhu: async params => {
    let url = `/qlkhambenh/don-thuoc-phu`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDonThuocPhu: async params => {
    let url = `/qlkhambenh/don-thuoc-phu?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
};

export default inpatientService;
